import React from 'react'

function CallToActionSix() {
    return (
        <div>
            {/* start call to action area */}
            <div className="rts-callto-acation-area rts-callto-acation-area4 bg-call-to-action-two">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="cta-two-wrapper">
                                <div className="title-area">
                                    <h3 className="title">
                                        Let’s discuss about how we can help <br />
                                        make your insurance better
                                    </h3>
                                </div>
                                <a className="rts-btn btn-primary-5" href="contactus.html">
                                    Lets Work Together
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end call to action area */}

        </div>
    )
}

export default CallToActionSix